function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".atag{fill:currentColor;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.999 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "atag",
  d: "M3.059,26.771a1.06,1.06,0,0,1-.75-1.809L7.961,19.31a1.06,1.06,0,0,1,1.5,1.5L3.809,26.461a1.06,1.06,0,0,1-.75.31Z",
  transform: "translate(0 -4.99)"
}), /*#__PURE__*/React.createElement("path", {
  className: "atag",
  d: "M15.354,5.406l.076.028,1.657-1.657-.994-.357c-.152-.058-3.731-1.4-6.075.946L4.366,10.017c-2.343,2.345-1,5.924-.954,6.053l.365,1.017,1.657-1.657-.035-.1c-.009-.024-.892-2.457.467-3.815l5.652-5.652C12.886,4.5,15.311,5.39,15.354,5.406Z",
  transform: "translate(-0.29 -0.29)"
}), /*#__PURE__*/React.createElement("path", {
  className: "atag",
  d: "M20.734,10.787l-.028-.076,1.661-1.657.353.994c.058.152,1.4,3.731-.946,6.075l-5.652,5.652c-2.345,2.343-5.924,1-6.053.954l-1.017-.362,1.657-1.66.1.035c.024.009,2.457.892,3.815-.467l5.652-5.652C21.641,13.258,20.751,10.829,20.734,10.787Z",
  transform: "translate(-2.071 -2.071)"
}), /*#__PURE__*/React.createElement("path", {
  className: "atag",
  d: "M20.059,9.771a1.06,1.06,0,0,1-.75-1.809L24.962,2.31a1.06,1.06,0,1,1,1.5,1.5L20.809,9.461a1.06,1.06,0,0,1-.75.31Z",
  transform: "translate(-4.99)"
}));

var SvgAtag = function SvgAtag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.781,
    height: 19.781,
    viewBox: "0 0 19.781 19.781",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/atag.353cba33.svg";
export { ForwardRef as ReactComponent };